import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.for-each";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useReducer, useState } from 'react';
import produce from 'immer';
import Field from './Field';
import { getEndpoint } from './index';
import { Form, Submit, Person, Error, loading } from './styles';
var reducer = produce(function (state, action) {
  switch (action.type) {
    case 'SET_VALUE':
      {
        var _action$payload = action.payload,
            person = _action$payload.person,
            field = _action$payload.field,
            value = _action$payload.value,
            sync = _action$payload.sync;
        if (!state.people[person][field]) state.people[person][field] = {};
        state.people[person][field].value = value;
        state.people[person][field].touched = true;

        if (person === 0 && sync) {
          state.people.forEach(function (person, index) {
            if (!person[field]) person[field] = {};

            if (!person[field].touched) {
              person[field].value = value;
            }
          });
        }

        return;
      }

    case 'SET_GUEST':
      {
        var _action$payload2 = action.payload,
            _person = _action$payload2.person,
            _field = _action$payload2.field,
            _value = _action$payload2.value;
        if (!state.people[_person][_field]) state.people[_person][_field] = {};
        state.people[_person][_field].value = _value;
        state.people[_person][_field].touched = true;
        state.meta.guest = _value === '1';

        if (_value === '1') {
          state.people.push({
            __isGuest: {
              field: '__isGuest',
              value: true,
              touched: false
            }
          });
        } else {
          state.people = state.people.filter(function (person) {
            return !person.__isGuest;
          });
        }

        return;
      }

    default:
      return;
  }
});
export default function WeddingForm(props) {
  var _useState = useState('idle'),
      fetchState = _useState[0],
      setFetchState = _useState[1];

  var _useState2 = useState(null),
      fetchResponse = _useState2[0],
      setFetchResponse = _useState2[1];

  var _useReducer = useReducer(reducer, props.initialState),
      state = _useReducer[0],
      reduce = _useReducer[1];

  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    setFetchState('loading');
    window.fetch(getEndpoint() + '/submit?site=' + (process.env.SITE_ID || '') + '&code=' + props.code, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(state.people)
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      setFetchResponse(response);
      setFetchState('finished');
    })["catch"](function (error) {
      console.error(error);
      setFetchState('error');
    });
  };

  var last = state.people.length - (state.meta.guest ? 2 : 1);
  var isLoading = fetchState === 'loading';
  return jsx(Form, {
    onSubmit: onSubmit
  }, state.people.map(function (person, index) {
    return jsx(Person, {
      key: index
    }, props.fields.map(function (field, i) {
      return jsx(Field, {
        key: i,
        person: index,
        first: index === 0,
        last: index === last,
        state: state,
        reduce: reduce,
        field: field
      });
    }));
  }), jsx(Submit, {
    css: isLoading ? loading : null,
    disabled: isLoading
  }, "Odeslat"), fetchState === 'error' ? jsx(Error, {
    className: "mt--10"
  }, "N\u011Bco se pokazilo") : null, fetchState === 'finished' ? jsx(Error, {
    className: "mt--10"
  }, "D\u011Bkujeme") : null);
}